import React from 'react';

import {
  Accordion as AccordionWrapper,
  AccordionDetails,
  AccordionSummary,
  Divider,
} from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

const unmountTransitionProps = { unmountOnExit: true };

const Accordion = ({
  id,
  defaultExpanded = true,
  top,
  bottom,
  isWithDivider = true,
  isWithExpandIcon = true,
  TransitionProps,
  unmountOnExit = false,
  ...props
}) => {
  return (
    <AccordionWrapper
      TransitionProps={unmountOnExit ? unmountTransitionProps : TransitionProps}
      defaultExpanded={defaultExpanded}
      {...props}
    >
      <AccordionSummary
        aria-controls={`${id}-content`}
        expandIcon={isWithExpandIcon && <ArrowCheckIcon direction={IconDirection.DOWN} />}
        id={`${id}-header`}
      >
        {top}
      </AccordionSummary>

      {isWithDivider && <Divider />}

      <AccordionDetails>{bottom}</AccordionDetails>
    </AccordionWrapper>
  );
};

Accordion.propTypes = {
  id: PropTypes.string.isRequired,
  top: PropTypes.element.isRequired,
  bottom: PropTypes.element.isRequired,
  isWithDivider: PropTypes.bool,
  isWithExpandIcon: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  TransitionProps: PropTypes.object,
  unmountOnExit: PropTypes.bool,
};

export default Accordion;
